export default {
  // Accumulate 筛选器 开始
  'common_Separated': '分维度',
  'common_Accumulated': '累计值',
  'common_Dimension': '维度',
  'common_by_Date': '分日期',
  'common_by_Time': '分时间',
  'common_by_Zone': '分区服',
  'common_Zone': '区服',
  'common_by_Region': '分区域',
  'common_Region': '区域',
  'common_by_Country': '分国家',
  'common_Country': '国家',

  'common_by_Category': '分产品类型',
  'common_Category': '产品类型',
  'common_by_Product': '分产品',
  'common_Product': '产品',
  'common_by_catalog': '分游戏分类',
  'common_catalog': '游戏分类',

  'common_by_System': '分平台',
  'common_System': '平台',
  'common_by_Channel': '分渠道',
  'common_Channel': '渠道',
  'common_by_Language': '分语言',
  'common_Language': '语言',
  'common_by_Bundle': '分渠道包',
  'common_Bundle': '渠道包',
  'common_by_churn_level': '分流失等级',
  'common_by_Churn_Level': '分流失等级',
  'common_Churn_level': '流失等级',
  'common_churn_level': '流失等级',
  'common_by_netWork_Type': '分网络类型',
  'common_ua_network': '买量渠道',
  "common_campaign": 'Campaign',
  'common_by_ua_network': '分买量渠道',
  'common_by_campaign': '分 Campaign',
  "common_ab_test": 'AB Test',
  'common_by_ab_test': '分 AB Test',
  'common_version': '版本',
  'common_by_version': '分版本',
  'common_ad_format': '广告类型',
  'common_by_ad_format': '分广告类型',
  'common_pv_threshold': '事件触发次数',
  'common_by_pv_threshold': '分事件触发次数',

  'common_casual_network_type': '渠道类型',
  'common_by_network_type': '分渠道类型',
  'common_netWork_Type': '网络类型',
  'common_network_Type': '网络类型',
  'common_media_source': '买量渠道',
  'common_country_top_10': 'Top 10 国家',
  'common_region_top_10': 'Top 10 区域',
  'common_newtwork_top_10': 'Top 10 网络类型',
  'common_zone_top_10': 'Top 10 区服',
  'common_platfrom_top_10': '各平台',
  'common_language_top_10': '各语言',
  'common_channel_top_10': 'Top 10 渠道',

  'common_country_region_zone_breakdown': '国家/区域/区服排行榜',
  'common_country_system_language_breakdown': '国家/平台/语言 排行榜',

  // 更多/收起
  'common_more': '更多',
  'common_close': '收起',
  // Accumulate 筛选器 结束

  // 运算筛选器 key
  'common_Sum': '汇总值',
  'common_Avg': '平均值',
  'common_Max': '最大值',
  'common_Min': '最小值',
  'common_Average': '平均值',
  'common_Average(remove_Null)': '均值(去空)',
  'common_Average(remove_Null&0)': '均值(去空和0)',
  'common_Count': '计数',

  // 运算筛选器 key 结束
  'common_sum': '汇总值',
  'common_max': '最大值',
  'common_min': '最小值',
  'common_average': '平均值',
  'common_avg': '平均值',
  'common_avg_no_null': '均值(去空)',
  'common_avg_no_null_zero': '均值(去空和0)',
  'common_count': '计数',

  // 宽表上方选择是否展示同比环比
  'common_value_only': "仅展示指标值",
  'common_show_change': "展示变化率",
  'common_show_dod_Day': "展示环比",
  'common_show_dod_Week': "展示环比",
  'common_show_dod_Month': "展示环比",
  'common_show_sdlw_Day': "展示同比",
  'common_show_sdlw_Week': "展示同比",
  'common_show_sdlw_Month': "展示同比",

  // 表格列 标题
  'common_zone': '区服',
  'common_region': '区域',
  'common_country': '国家',
  'common_system': '平台',
  'common_channel': '渠道',
  'common_language': '语言',
  'common_bundle': '渠道包',
  'common_app_version': 'App版本',
  'common_network_type': '网络类型',
  'common_memory': '内存',
  'common_store_channel': '商店渠道',
  'common_category': '产品类型',
  'common_product': '产品',

  // 分页器
  'common_records': '条记录',
  'common_page': '页',
  'common_share': '占比',
  'common_discount': '折扣',
  'common_discount_avg': '平均折扣',
  'common_total': '汇总',

  'date': '日期',
  'common_date': '日期',
  'common_time': '时间',
  'common_level': '等级',
  'common_day_of_week': '星期',

  // 无数据提示
  'common_nodata': '当前筛选条件下无数据。',
  'common_loading': '加载中...',
  'common_loading_failed': '加载失败',
  'common_loading_failed_realtime': '暂无数据',
  'common_not_found': "未找到搜索内容",
  'common_go_back_table': '返回原列表',
  'common_retry_table': "刷新重试",
  'common_event_selector_nodata': '暂无数据',
  'common_discount_nodata': '当前选择的国家无打折信息',

  // 留存
  // 应产品需求，改为次留、3留、7留
  'common_d2': '次留',
  'common_d3': '3留',
  'common_d7': '7留',

  // 指标卡片
  'today': '当天',
  'week': '当周',
  'month': '当月',

  'card_today': '当天',
  'card_week': '当周',
  'card_month': '当月',

  'sum': '汇总值',
  'avg': '平均值',

  'wow': '周环比',
  'swlm': '上月同期',
  'dod': '日环比',
  'sdlw': '上周同期',
  'mom': '月环比',
  'smly': '去年同期',
  'change': '变化率',
  'contrast day': '对比日',
  'common_today': '今天',
  'common_yesterday': '昨天',
  'common_sdlw': '上周同期',
  'common_data_toptip_text': '平台计算的时区为UTC0时区，前一天的数据更新时间约为北京时间上午10：30-11：30。',
  'common_data_toptip_text_fam_jp': '平台计算的时区为UTC9时区，前一天的数据更新时间约为北京时间上午2：00-3：00。',
  'common_down_success_text': '下载成功',
  'common_down_error_text': '下载失败',
  'common_down_loading_text': '下载中',

  'common_mon': '周一',
  'common_tues': '周二',
  'common_wed': '周三',
  'common_thur': '周四',
  'common_fri': '周五',
  'common_sat': '周六',
  'common_sun': '周日',

  'common_others': '其他',
  'common_contrast': '对比',

  'common_day': '日',
  'common_week': '周',
  'common_month': '月',

  'common_days': '日',
  'common_weeks': '周',
  'common_months': '月',

  'common_timezone': '时区',

  'common_pages': '页面',
  'common_metrics': '指标',
  'common_customized_metrics': '特性指标',
  'common_no_report_serach': '当前关键字无匹配项',

  'common_confirm': '确定',
  'common_cancel': '取消',
  'common_all': '全部',
  'common_back': '返回',
  'common_customize': '自定义',

  'common_select_placeholder': '请选择',
  // 'common_select_placeholder_path': '请选择页面路径',
  // 'common_select_placeholder_work': '请选择Workbook Url',
  // 'common_select_placeholder_url': '请输入Url',
  // 'common_select_placeholder_datalab': 'Please Select Datalab',
  // 'common_select_placeholder_preset': 'Please Select Preset',


  'common_line_chart': '折线图',
  'common_funnel_chart': '漏斗图',
  'common_bar_chart': '柱状图',
  'common_stack_line_chart': '堆积折线图',
  'common_pie_chart': '饼图',
  'common_Tree': '树状图',
  'common_map_chart': '世界地图',
  'common_table': '表格',
  'common_down_load': '下载',
  'common_download_image': '保存为图片',

  'common_show_values': '显示数值',
  'common_hide_values': '隐藏数值',
  'common_show_event': '显示事件起始日',
  'common_hide_event': '显示事件时间范围',
  'common_comparison_analysis': '对比分析',
  'common_show_all': '更多',
  'common_show_less': '收起',

  'data_tag_bubble_hidden': "隐藏数值。",
  'data_tag_bubble_show': "显示数值。",
  'change_tag_bubble_show': "Y = 最小值",
  'change_tag_bubble_hidden': "Y = 0",
  'common_search_no_data': '当前搜索条件下无数据',

  'common_select_content_download': '请选择下载内容',

  'common_publish_filter_please': '请输入正确的日期',
  'common_publish_filter_date_out': '日期超出范围',
  'common_publish_filter_date_should': '日期应该小于365天',

  'common_table_downloading': '下载中',
  'common_table_download_success': '下载成功',
  'common_table_download_failed': '下载失败',
  'common_region_market': '国家/市场',

  'common_day_num': '{num}{suffix}',

  'common_system_admin': '管理端',
  // 表单错误提示
  'form_error_message_not_empty': "不可为空",
  'form_error_message_limit_length': "长度不超过{length}字符.",
  'form_error_message_empty_limit': "不可为空, 且不超过{length}字符",
  'form_error_message_exists': "已存在, 请重新输入",

  'common_overview': "总览",
  'common_realtime': "实时数据",

  "common_edit": '编辑',
  "common_delete": '删除',
  'common_setting': '设置',
  'common_comming': "即将上线，敬请期待。",

  'common_back_to_old_link': "返回旧版",

  'common_copy_success': "复制成功",
  'common_copy_fail': "复制失败",

  "common_copy_date_column": '复制日期列',
  "common_copy_time_column": '复制时间列',
  "common_copy_contrast_date_column": '复制对比时间列',
  "common_asc": '升序',
  "common_des": '降序',
  "common_asc_by_rate": '按变化率升序',
  "common_des_by_rate": '按变化率降序',
  "common_default_sort": '恢复默认排序',
  "common_copy_this_column": '复制本列数据',
  "common_copy_this_column_and_date": '复制本列数据与日期列',
  "common_copy_this_column_and_time": '复制本列数据与时间列',
  'common_filter_save_date_bubble_tips': '按照最新时间自动刷新',
  'common_data': "数据",
  'form_error_message_empty_30_limit': "不超过30字符",
  'form_error_message_empty_80_limit': "不超过80字符",
  'form_error_message_empty': "不可为空",
  'common_component_update': '组件正在更新中',
  'common_common': '常用',
  'common_event': '事件',
  'common_search': '搜索',
  'common_event_type': '事件类型',
  'common_event_name': '事件名称',

  'common_woa_no_game_permission': '您目前无法查看当前游戏数据，请点击下方按钮申请对应权限。',
  'common_global_no_game_permission': '您目前无法查看当前游戏数据，请联系组织管理员开通权限。',
  'common_filter_payment_type_tooltip': '产品付费类型',
  'dbd_over_limit_tip_prefix': '当前查询数据量已超过 {count}，全量明细请',
  'dbd_over_limit_tip_link': '下载',
  'dbd_over_limit_tip_suffix': '报表查看。',

  // 异动日报下载
  'dbd_download_html': 'HTML',
  'dbd_download_pdf': 'PDF',
  'dbd_download_format': '格式',
};
